module.exports = __webpack_public_path__ + "img/amazon.3ec9d466.svg";